import React from "react";
import { useMobile } from "../hooks/custom/useMobile";
import useTab from "../hooks/custom/useTab";

interface Props {
  title?: string;
  tabs: {
    id: string;
    label: string;
  }[];
  activeTab: string;
  handleTabClick: (hash: string) => void;
  openSidebar: boolean;
  setOpenSidebar: React.Dispatch<React.SetStateAction<boolean>>;
}

const TabSidebar = ({
  title,
  tabs,
  activeTab,
  handleTabClick,
  openSidebar,
  setOpenSidebar,
}: Props) => {
  const mobile = useMobile();
  const tab = useTab();

  //   useEffect(() => {
  //     const matchedProgram = programsDetails.find(
  //       (item) =>
  //         item.title.toLowerCase() === decodeURIComponent(program).toLowerCase(),
  //     );

  //     if (matchedProgram) {
  //       setOpenMenu(matchedProgram.title);
  //     }

  //     const matchedCourse = matchedProgram?.courses.find(
  //       (item) =>
  //         item.name.toLowerCase() === decodeURIComponent(course).toLowerCase(),
  //     );

  //     if (matchedCourse) {
  //       setOpenSubMenu(matchedCourse.name);
  //     }
  //   }, [programsDetails, program, course]);

  return (
    <>
      <div
        className={`sidebar_overlay ${openSidebar ? "show_overlay" : ""}`}
        onClick={() => setOpenSidebar(false)}
      />
      <div
        className={`col-lg-3 tabs_wrapper ${openSidebar ? "tabs_open" : ""}`}
      >
        <div className="sidebar_menu">
          {
            <div className="sidebar_mobile_header">
              <button
                className="sidebar_close_btn"
                onClick={() => setOpenSidebar(false)}
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>
          }
          <h2
            className={`${mobile || tab ? "td_fs_36" : "td_fs_48"}`}
            style={
              mobile || tab
                ? {
                    width: "90%",
                  }
                : {}
            }
          >
            {title}
          </h2>

          <div className="sidebar_line" />
          {tabs.map((tab, index) => (
            <div key={index} className="sidebar_item">
              <div
                className={`sidebar_heading ${activeTab === tab.id ? "sidebar_active" : ""}`}
                onClick={() => {
                  handleTabClick(tab.id);
                  setOpenSidebar(false);
                }}
              >
                <div className="sidebar_heading_left">
                  <h6>{tab.label}</h6>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default TabSidebar;
